<template>
  <f7-page
    :theme-dark="dark"
    id="route">

    <f7-navbar
      back-link
      :theme-dark="dark"
      :title="t('routeTitle')" />

    <LMap
      v-if="routeMarker"
      :zoom="12"
      :center="[routeMarker.coords[1], routeMarker.coords[0]]"
      height="200px"
      :options="opts">
      <LMapboxGL
        :url="tiles"
        attribution="<a href='https://www.maptiler.com/copyright/' target='_blank' rel='noopener'>© MapTiler</a> <a href='https://www.openstreetmap.org/copyright' target='_blank' rel='noopener'>© OSM</a>" />
      <LMarker
        ref="marker"
        :latlng="[routeMarker.coords[1], routeMarker.coords[0]]">
        <LAwesomeMarker
          :options="{
            icon: 'circle',
            markerColor: 'red',
            prefix: 'fa'
          }" />
      </LMarker>
    </LMap>
    <RouteElevation
      v-if="routePath && routePath.points"
      :points="routePath.points.coordinates"
      :distance="distance" />
    <RouteInstructions
      v-if="routeInstructions.length"
      :instructions="routeInstructions"
      :distance="distance"
      @click="click" />
  </f7-page>
</template>

<script>
import { tilesStyles } from '@/services/maptiler'
import { mapGetters } from 'vuex'
import RouteElevation from '@/components/ui/Route/RouteElevation'
import RouteInstructions from '@/components/ui/Route/RouteInstructions'
export default {
  name: 'Route',
  components: {
    RouteElevation,
    RouteInstructions
  },
  data () {
    return {
      opts: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        boxZoom: false,
        scrollWheelZoom: false
      },
      breakpoint: 500
    }
  },
  computed: {
    ...mapGetters({
      geoPos: 'global/geoPos',
      routeMarker: 'global/routeMarker',
      routePolyline: 'global/routePolyline',
      routeInstructions: 'global/routeInstructions',
      routePath: 'global/routePath'
    }),
    tiles () { return tilesStyles(this.setting('tiles')) },
    posPoint () {
      return this.geoPos && this.geoPos.length ? this.$turf.point([this.geoPos[1], this.geoPos[0]]) : null
    },
    nearestPoint () {
      return this.posPoint && this.routePath ? this.$turf.nearestPointOnLine(this.routePath.points, this.posPoint, { units: 'kilometers' }) : null
    },
    far () {
      return this.nearestPoint ? this.nearestPoint.properties.dist * 1000 : 0
    },
    away () {
      return this.far ? this.far > this.breakpoint : 0
    },
    distance () {
      return this.nearestPoint ? this.nearestPoint.properties.location * 1000 : 0
    }
  },
  methods: {
    click (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss">
</style>
